import { defineStore } from "pinia";
import { api, type ConversationSummary } from "../api";

/**
 * The conversation list, shared between the nav (which renders it as a tree under Chat) and the
 * chat view (which refreshes it when a new conversation is created).
 */
export const useConversations = defineStore("conversations", {
  state: () => ({
    list: [] as ConversationSummary[],
    loaded: false,
  }),
  actions: {
    async load(): Promise<void> {
      try {
        this.list = await api.conversations();
        this.loaded = true;
      } catch {
        // The list is a navigation convenience; a failed refresh shouldn't take the nav down.
        // The chat view surfaces API errors where the user is actually working.
      }
    },
    /** Soft-delete: the record is archived, not destroyed, and admins keep seeing it (ADR-0009). */
    async remove(id: string): Promise<void> {
      await api.archiveConversation(id, true);
      await this.load();
    },
  },
});
